<template>
   
    <el-drawer
        v-model="drawer.show"
        title="评价"
        direction="rtl"
        custom-class="evaluate-dialog"
        :before-close="handleClose"
    >
        <el-row class="rate-evaluate">
            <el-col :span="4">服务评价</el-col>
            <el-col :span="20" class="rate-rg">
                <el-rate v-model="dataFrom.serviceRating" size="large" show-score text-color="#000000" score-template="{value} 分" />
            </el-col>
            <el-col :span="4">物流评价</el-col>
            <el-col :span="20" class="rate-rg">
                <el-rate v-model="dataFrom.logisticsRating" size="large" show-score text-color="#000000" score-template="{value} 分" />
            </el-col>
            <el-col :span="4">评价内容</el-col>
            <el-col :span="24">
                <el-input
                    v-model="dataFrom.evaluationContent"
                    :rows="4"
                    type="textarea"
                    maxlength="200"
                    placeholder="请输入评价内容或选择标签进行评价"
                />
                <div class="tag-remak">
                    <el-tag  style="margin-right: 5px;" :closable="false" @click="handleTagClick(obj)"  :key="idx" v-for="(obj,idx) in remarkTag">
                        {{ obj }}
                    </el-tag>
                </div>
            </el-col>

            <el-col :span="24">
                <ab-upload
                    :params="uploadParams"
                    ref="fileUpload"
                >
                
                </ab-upload>
            </el-col>

        </el-row>
        
        <template #footer>
            <div style="text-align: center">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" :loading="isloading" @click="handleConfirm">确定</el-button>
            </div>
        </template>
  </el-drawer>
</template>

<script>
export default {
    data () {
        return {
            drawer: {
                show: false
            },
            dataFrom: {
                serviceRating: '',
                logisticsRating: '',
                evaluationContent: '',
                avatarUrl: ''
            },
            remarkTag: [
                '报关效率快',
                '客服有耐心',
                '付汇很便捷',
                '送货很准时',
                '系统很方便'
            ],
            uploadParams: {
                coreBillIds: "",
                coreBillNumbers: "",
                sourceBillId: "",
                sourceBillNumber: "",
                sourceBillType: "EntrustAll",
                billsType: "",
                items: [
                    {
                        title: "评价文件",
                        attachType: "120",
                        required: false
                    },
                ]
            },
            isloading: false
        }
    },
    methods: {
        init (row) {
            this.dataFrom.serviceRating = ''
            this.dataFrom.logisticsRating = ''
            this.dataFrom.evaluationContent = ''
            this.dataFrom.parentId = row.id
            this.uploadParams.sourceBillId = row.id
            this.getAttachUrl()
            this.drawer.show = true
        },
        // 获取头像url
        getAttachUrl() {
            this.$post('/p/user/getAttachUrlById').then(({ data }) => {
                if(data.code === 'C0000') {
                    this.dataFrom.avatarUrl = data.message || ''
                }
            })
        },
        handleClose () {
            this.uploadParams.sourceBillId = ''
            this.drawer.show = false
        },
        handleConfirm () {
            if (!this.dataFrom.serviceRating) {
               return this.$message.error('请您为服务评价打分！')
            }
            if (!this.dataFrom.logisticsRating) {
               return this.$message.error('请您为物流评价打分！')
            }
            this.isloading = true
            this.$post('/oms/client/entrustImportEvaluation/add', this.dataFrom).then(({data}) => {
                if (data && data.code == 'C0000') {
                    this.$message.success('评价成功！')
                    this.handleClose()
                    this.$emit('changeList')
                }
            }).finally(() => {
                this.isloading = false
            })

        },
        handleTagClick (obj) {
            if (this.dataFrom.evaluationContent.trim() == '') {
                this.dataFrom.evaluationContent += obj
            } else {
                this.dataFrom.evaluationContent = this.dataFrom.evaluationContent + ';' + obj
            }
        }
    }
}
</script>

<style lang="scss">
.evaluate-dialog {
    .el-drawer__body {
        padding: 30px;
    }
}
.rate-evaluate {
    font-size: 16px;
    .el-col-4, .el-col-20{
        display: flex;
        align-items: center;
    }
    .el-col-4 {
        line-height: 40px;
    }
    .rate-rg {
        justify-content: flex-end;
    }
    .el-rate {
        --el-rate-icon-size: 26px;
        --el-rate-fill-color: #f34545;
    }
    .tag-remak {
        margin-top: 10px;
        .el-tag {
            cursor: pointer;
            color: #F87243;
            background-color: #FEEAE3;
            border:none;
            height: 36px;
            .remark-content {
                width: 300px;
                font-size: 15px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
            }
            .el-icon-close {
                top: -10px;
            }
            .el-icon{
                color: #999999;
                &:hover{
                    background-color: transparent !important;
                }
            }
        }
    }
    
}
</style>